import * as React from 'react'
import { FallbackForm } from '../components/FallbackForm';
import { OverlayPage } from '../components/Overlay/OverlayPage'
import { Icon, IconType, Link, Text } from 'DVWebNodeUI';
import * as styles from './TellUsMorePage.module.scss'
import { TellUsWhyAction, TellUsWhyOutput } from "@utils";

interface TellUsWhyPageProps {
    action: TellUsWhyAction
    onSuccess?: () => void
    onExit?: () => void
}

interface TellUsWhyPageState {
    message?: string
}


export class TellUsWhyPage extends React.Component<TellUsWhyPageProps, TellUsWhyPageState> {
    constructor(props: TellUsWhyPageProps) {
        super(props)
        this.state = {}
    }

    icon() {
        return <a onClick={() => setTimeout(this.props.onExit, 1000)}>
            <Icon use={IconType.ALERT_PRIME_CLOSE} />
        </a>

    }

    successPage() {
        return <OverlayPage>
            <div className={styles.title}><Text tag="h4" >{this.state.message}</Text></div>
        </OverlayPage>
    }

    mainPage() {
        const list =
            this.props.action.options &&
            this.props.action.options.map((val) => {
                return <div className={styles.options}><FallbackForm endpointUrl={val.endpoint} onSuccess={
                    [(out: TellUsWhyOutput) => {
                        this.props.onSuccess()
                        this.setState({ message: out.message })
                    }]
                }>
                    <Link>{val.text}</Link>
                </FallbackForm>
                </div>

            })

        const content = <div className={styles.body}>
            <Text tag="h5">{this.props.action.text}</Text>
            {list} </div>
        return <OverlayPage header={<div className={styles.displayFlexEnd}>{this.icon()}</div>}>
            {content}
        </OverlayPage>

    }

    render() {
        return this.state.message ? this.successPage() : this.mainPage()
    }
}